export const environment = {
    API_URL: "https://dev-api.cyberforcehq.com/api/",
    // API_URL: "http://localhost:5000/api",
    GOOGLE_CLIENT_ID : "294866301838-18q8so7afig60sosje4dl09jdhrfr04k.apps.googleusercontent.com",
    OFFICE365_CLIENT_ID: '28a9fa0f-3b98-4a67-9724-d2fc8562d8a4',
    OFFICE365_TENANT_ID: '45d4673d-c6e7-4dbc-b812-cbfe09686016',
    LINKEDIN_API_KEY: "77dpu86k9m25q3",
    LINKEDIN_REDIRECT_URL: "https://dev-employee.cyberforcehq.com/linkedin",
    LINKEDIN_SCOPE: "openid email profile"
};
